import type { Entity } from '@ms/yammer-data-support';

import type { Thread } from '../types';

export type MessageBodyCollapsingLayoutType = 'CollapsedPinned' | 'Collapsed' | 'Expanded';

export type AttachmentsCollapsingLayoutType = 'Collapsed' | 'PartlyCollapsed' | 'Expanded';

export type ReplyCollapsingLayoutType = 'Collapsed' | 'Expanded';

export interface ThreadLayout extends Entity {
  readonly threadStarterBody: MessageBodyCollapsingLayoutType;
  readonly threadStarterAttachments: AttachmentsCollapsingLayoutType;
  readonly replies: ReplyCollapsingLayoutType;
}

export type ThreadLayouts = Record<Thread['id'], ThreadLayout>;

export const defaultThreadStarterBodyLayout = 'Collapsed' as const;
export const defaultThreadStarterAttachmentsLayout = 'Expanded' as const;
export const defaultRepliesLayout = 'Collapsed' as const;
